import { render, staticRenderFns } from "./WorkflowView.vue?vue&type=template&id=52919596&scoped=true&"
import script from "./WorkflowView.vue?vue&type=script&lang=js&"
export * from "./WorkflowView.vue?vue&type=script&lang=js&"
import style0 from "./WorkflowView.vue?vue&type=style&index=0&id=52919596&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52919596",
  null
  
)

export default component.exports